import { ajaxController } from './controller/AjaxController'

export interface ShiftBandDto {
  shift: string
  shiftNumber: number
  startTime: string
  durationHours: number
}

export interface RehandleConfigResponse {
  collectsTruckBucketType: boolean
}

export interface ShiftBandsResponse {
  timeZone: string
  shiftBands: ShiftBandDto[]
}

class ConfigAjax {
  async getShiftBands() {
    return ajaxController.get<ShiftBandsResponse>('/Config/shift-bands', {})
  }

  async getRehandleConfig() {
    return ajaxController.get<RehandleConfigResponse>('/Config/rehandle', {})
  }
}

export const configAjax = new ConfigAjax()
